import { useTranslateKey } from "../translation/useTranslateKey";
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaEnvelope,
  FaTimes,
} from "react-icons/fa";
import { API_BASE_URL } from "../../api/config";


const SharePopup = ({ show, onClose, propertyId, propertyTitle }) => {
  const t = useTranslateKey();

  if (!show) return null;

  const shareOnSocial = (platform) => {
    let shareUrl = "";
    const encodedUrl = encodeURIComponent(
      `${API_BASE_URL}/property-details/${propertyId}`
    );
    const encodedTitle = encodeURIComponent(propertyTitle);

    switch (platform) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
        break;
      case "instagram":
        // Note: Instagram doesn't support direct sharing, this would open the app
        shareUrl = `https://www.instagram.com/`;
        break;
      case "tiktok":
        shareUrl = `https://www.tiktok.com/`;
        break;
      default:
        return;
    }

    window.open(shareUrl, "_blank", "width=600,height=400");
  };

  return (
    <div
      className="fixed inset-0 flex items-start justify-center z-50 pt-20"
      style={{ backgroundColor: "rgba(18, 21, 37, 0.98)" }}
    >
      <div
        className="bg-[#11132F] border-2 border-[#332D7E] rounded-xl p-8 max-w-md w-full mx-4 relative shadow-2xl"
        style={{ backgroundColor: "#11132F" }}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3  text-gray-400 hover:text-white"
          style={{ right: ".75rem" }}
        >
          <FaTimes className="text-lg" />
        </button>

        <h3 className="text-xl font-bold text-white mb-4">
          {t("shareThisProperty")}
        </h3>

        <div className="flex justify-center gap-4 mb-4">
          <button
            onClick={() => shareOnSocial("facebook")}
            className="w-10 h-10 flex items-center justify-center bg-[#1877f2] hover:bg-[#166fe5] text-white rounded-full transition-colors"
          >
            <FaFacebook className="text-blue-600 text-2xl mb-2" />
          </button>

          {/* <button
            onClick={() => shareOnSocial("twitter")}
            className="w-10 h-10 flex items-center justify-center bg-[#1da1f2] hover:bg-[#1a91da] text-white rounded-full transition-colors"
          >
            <FaXTwitter className="text-blue-400 text-2xl mb-2" />
          </button> */}

          <button
            onClick={() => shareOnSocial("instagram")}
            className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#405de6] via-[#833ab4] to-[#e1306c] hover:opacity-90 text-white rounded-full transition-colors"
          >
            <FaInstagram className="text-pink-600 text-2xl mb-2" />
          </button>

          <button
            onClick={() => shareOnSocial("tiktok")}
            className="w-10 h-10 flex items-center justify-center bg-black hover:bg-gray-900 text-white rounded-full transition-colors"
          >
            <FaTiktok className="text-black text-2xl mb-2" />
          </button>
        </div>

        {/* Email share */}

        <a
          href={`mailto:?subject=Check out this property: ${propertyTitle}&body=I found this amazing property: ${API_BASE_URL}/property-details/${propertyId}`}
          className="flex items-center justify-center gap-2 w-full px-4 py-2 bg-[#EA4335] hover:bg-[#d33426] text-white rounded-md transition-colors"
        >
          <FaEnvelope className="text-red-500 text-2xl mb-2" />
          <span>{t("shareViaEmail")}</span>
        </a>
      </div>
    </div>
  );
};

export default SharePopup;
